import { apiService } from './api';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatMessageRequest {
  message: string;
  conversationHistory?: ChatMessage[];
  preferredResponseLanguage?: string;
}

export interface ChatMessageResponse {
  message: string;
  success: boolean;
}

class ChatService {
  /**
   * Send a message to the AI chat
   */
  async sendMessage(
    message: string,
    conversationHistory?: ChatMessage[],
    preferredResponseLanguage?: string
  ): Promise<ChatMessageResponse> {
    try {
      const request: ChatMessageRequest = {
        message,
        conversationHistory,
        preferredResponseLanguage
      };

      const response = await apiService.post<ChatMessageResponse>(
        '/api/Chat/message',
        request
      );

      return response;
    } catch (error: any) {
      console.error('Chat service error:', error);
      throw new Error(
        error?.message || 'Failed to send message. Please try again.'
      );
    }
  }
}

export const chatService = new ChatService();

